import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Layout from "./pages/Layout";
import LandingPage from "./pages/LandingPage";
import LeadershipSkills from "./pages/LeadershipSkills";
import ExperienceProjects from "./pages/ExperienceProjects";
import Testimonials from "./pages/Testimonials";
import AboutMe from "./pages/AboutMe";

function App() {
	return (
		<Router>
			<div className="flex flex-col min-h-screen bg-slate-50">
				<Routes>
					<Route path="/" element={<Layout />}>
						<Route index element={<LandingPage />} />
						<Route path="leadership-skills" element={<LeadershipSkills />} />
						<Route path="experience-projects" element={<ExperienceProjects />} />
						<Route path="testimonials" element={<Testimonials />} />
						<Route path="about-me" element={<AboutMe />} />
					</Route>
				</Routes>
				<footer className="w-full mt-16 bg-primary">
					<div className="max-w-4xl mx-auto px-6 py-12 flex flex-col items-center text-center gap-6">
						<h2 className="text-white text-2xl md:text-3xl font-bold tracking-tight">
							Let's work together
						</h2>
						<p className="text-white/60 text-sm md:text-base max-w-md">
							Open to new opportunities in instructional technology, frontend development, and ed-tech. Feel free to reach out.
						</p>

						{/* Primary CTA */}
						<a
							href="mailto:daniel.middleton05@gmail.com"
							className="inline-block bg-accent hover:bg-opacity-90 text-white font-semibold px-8 py-3 rounded-full shadow-md transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg text-sm md:text-base"
						>
							daniel.middleton05@gmail.com
						</a>

						{/* Social links */}
						<div className="flex items-center gap-4 mt-2">
							<a
								href="https://www.linkedin.com/in/daniel-middleton-ab243598/"
								target="_blank"
								rel="noreferrer"
								className="text-white/50 hover:text-white text-sm font-medium transition-colors"
							>
								LinkedIn
							</a>
							<span className="text-white/20">|</span>
							<a
								href="https://github.com/danielmiddleton05"
								target="_blank"
								rel="noreferrer"
								className="text-white/50 hover:text-white text-sm font-medium transition-colors"
							>
								GitHub
							</a>
						</div>

						<p className="text-white/20 text-xs mt-4">
							© {new Date().getFullYear()} Daniel Middleton
						</p>
					</div>
				</footer>
			</div>
		</Router>
	);
}

export default App;
